"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = __importStar(require("query-string"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var modal_1 = __importDefault(require("../../../plugins/modal"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
// this modal works by checking for ?modal in the URL, also with &modalOpt1 for variable data
// check sections/account-url-modal.liquid for how to add new keys
var URLModal = function (_a) {
    var location = _a.location;
    var params = queryString.parse(location.search);
    if (!params.modal) {
        return null;
    }
    var urlModal = window.accountApp.settings.urlModal;
    var content = (0, replace_section_variables_1.default)(urlModal[params.modal], { modalOpt1: params.modalOpt1 }) || 'Content not found';
    var _b = __read(React.useState(true), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    return (React.createElement(modal_1.default, { isOpen: isModalOpen, handleClose: function () { return setIsModalOpen(false); } },
        React.createElement("div", { className: 'padding-12 padding-bottom-9', dangerouslySetInnerHTML: { __html: content } })));
};
exports.default = (0, react_router_dom_1.withRouter)(URLModal);
